import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-foreground text-background mt-24">
      <div className="max-w-[1500px] mx-auto px-5 sm:px-8 py-16 grid grid-cols-1 sm:grid-cols-3 gap-12">
        <div>
          <div className="font-heading font-black text-3xl tracking-tighter uppercase">Bundles and Blends<span className="text-accent">.</span></div>
          <p className="mt-4 text-sm text-white/60 max-w-xs">Editorial clothing, curated drops, and partner products — built for those who dress with intent.</p>
        </div>
        <div>
          <div className="text-xs font-bold tracking-[0.2em] uppercase text-white/40 mb-4">Navigate</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/shop" className="hover:text-accent transition-colors">Shop All</Link></li>
            <li><Link to="/cart" className="hover:text-accent transition-colors">Cart</Link></li>
            <li><Link to="/login" className="hover:text-accent transition-colors">Account</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs font-bold tracking-[0.2em] uppercase text-white/40 mb-4">Newsletter</div>
          <p className="text-sm text-white/60 mb-3">Get early access to drops.</p>
          <div className="flex border border-white/20">
            <input data-testid="newsletter-input" placeholder="Email address" className="bg-transparent px-3 py-2 text-sm flex-1 outline-none placeholder:text-white/40" />
            <button data-testid="newsletter-submit" className="bg-accent text-accent-foreground px-4 text-xs font-bold uppercase tracking-wider">Join</button>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-white/40 font-mono">© 2026 BUNDLES AND BLENDS — ALL RIGHTS RESERVED</div>
    </footer>
  );
}
